var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _radialGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 260 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7dde8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 130.387,
    x2: 130.387,
    xlinkHref: "#a",
    y1: 32.4814,
    y2: 86.7398
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 61.3527,
    x2: 61.3527,
    xlinkHref: "#a",
    y1: 13,
    y2: 85.5221
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 87.3214,
    x2: 87.3214,
    xlinkHref: "#a",
    y1: 21.2539,
    y2: 85.9285
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 22.3657,
    x2: 22.3657,
    xlinkHref: "#a",
    y1: 32.4814,
    y2: 86.7398
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 169.306,
    x2: 169.306,
    xlinkHref: "#a",
    y1: 13,
    y2: 85.5221
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 204.962,
    x2: 204.962,
    xlinkHref: "#a",
    y1: 32.3476,
    y2: 86.9422
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(18.3403 0 0 18.243 241.496 1.248)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6e71c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6e71c",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m151.53 52.4406v19.8895c0 5.6827.543 10.08 1.223 13.2596h-8.158c-.543-2.3678-.747-5.2091-.747-7.5093h-.204c-3.603 5.4798-9.654 8.6594-18.015 8.6594-10.877 0-17.607-6.4269-17.607-15.1539 0-8.524 4.826-13.9361 19.782-16.3039 4.623-.7442 10.945-1.4207 15.024-1.759v-2.0295c0-8.524-4.827-12.1096-11.761-12.1096-7.546 0-11.556 4.1944-11.896 10.283h-9.042c.544-9.8094 7.682-17.1834 20.87-17.1834 12.713-.1353 20.531 6.2916 20.531 19.9571zm-8.702 7.8476c-4.011.3382-9.653.9471-13.596 1.6236-8.906 1.353-11.965 3.8561-11.965 8.9976 0 5.2768 3.875 8.8623 10.673 8.8623 4.215 0 8.158-1.4207 10.741-4.0591 3.195-3.2472 4.215-6.0886 4.215-12.2448v-3.1796z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m151.53 52.4406v19.8895c0 5.6827.543 10.08 1.223 13.2596h-8.158c-.543-2.3678-.747-5.2091-.747-7.5093h-.204c-3.603 5.4798-9.654 8.6594-18.015 8.6594-10.877 0-17.607-6.4269-17.607-15.1539 0-8.524 4.826-13.9361 19.782-16.3039 4.623-.7442 10.945-1.4207 15.024-1.759v-2.0295c0-8.524-4.827-12.1096-11.761-12.1096-7.546 0-11.556 4.1944-11.896 10.283h-9.042c.544-9.8094 7.682-17.1834 20.87-17.1834 12.713-.1353 20.531 6.2916 20.531 19.9571zm-8.702 7.8476c-4.011.3382-9.653.9471-13.596 1.6236-8.906 1.353-11.965 3.8561-11.965 8.9976 0 5.2768 3.875 8.8623 10.673 8.8623 4.215 0 8.158-1.4207 10.741-4.0591 3.195-3.2472 4.215-6.0886 4.215-12.2448v-3.1796z",
    fill: "url(#b)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m56.832 85.5221v-72.5221h9.0415v72.5221z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m56.832 85.5221v-72.5221h9.0415v72.5221z",
    fill: "url(#c)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m101.767 78.0133v7.3063c-1.563.4059-3.8746.6089-5.7101.6089-9.9252 0-14.14-4.1944-14.14-14.8833v-30.1048h-9.0415v-7.171h9.0415v-12.5155h9.0415v12.5155h10.3326v7.1034h-10.3326v29.2253c0 5.8856 1.9714 8.3211 7.138 8.3211 1.2916.0676 2.7196-.1353 3.6706-.4059z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m101.767 78.0133v7.3063c-1.563.4059-3.8746.6089-5.7101.6089-9.9252 0-14.14-4.1944-14.14-14.8833v-30.1048h-9.0415v-7.171h9.0415v-12.5155h9.0415v12.5155h10.3326v7.1034h-10.3326v29.2253c0 5.8856 1.9714 8.3211 7.138 8.3211 1.2916.0676 2.7196-.1353 3.6706-.4059z",
    fill: "url(#d)",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m43.5078 52.4406v19.8895c0 5.6827.5438 10.08 1.2236 13.2596h-8.1577c-.5438-2.3678-.7478-5.2091-.7478-7.5093h-.2039c-3.603 5.4798-9.6533 8.6594-18.015 8.6594-10.87689 0-17.607-6.4269-17.607-15.1539 0-8.524 4.82664-13.9361 19.7824-16.3039 4.6227-.7442 10.945-1.4207 15.0238-1.759v-2.0295c0-8.524-4.8266-12.1096-11.7607-12.1096-7.5459 0-11.5567 4.1944-11.8966 10.283h-8.97351c.54385-9.8094 7.68184-17.1834 20.87011-17.1834 12.7124-.1353 20.4623 6.2916 20.4623 19.9571zm-8.7016 7.8476c-4.0109.3382-9.6533.9471-13.5962 1.6236-8.9055 1.353-11.9646 3.8561-11.9646 8.9976 0 5.2768 3.8749 8.8623 10.673 8.8623 4.2148 0 8.1577-1.4207 10.741-4.0591 3.1951-3.2472 4.2148-6.0886 4.2148-12.2448v-3.1796z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m43.5078 52.4406v19.8895c0 5.6827.5438 10.08 1.2236 13.2596h-8.1577c-.5438-2.3678-.7478-5.2091-.7478-7.5093h-.2039c-3.603 5.4798-9.6533 8.6594-18.015 8.6594-10.87689 0-17.607-6.4269-17.607-15.1539 0-8.524 4.82664-13.9361 19.7824-16.3039 4.6227-.7442 10.945-1.4207 15.0238-1.759v-2.0295c0-8.524-4.8266-12.1096-11.7607-12.1096-7.5459 0-11.5567 4.1944-11.8966 10.283h-8.97351c.54385-9.8094 7.68184-17.1834 20.87011-17.1834 12.7124-.1353 20.4623 6.2916 20.4623 19.9571zm-8.7016 7.8476c-4.0109.3382-9.6533.9471-13.5962 1.6236-8.9055 1.353-11.9646 3.8561-11.9646 8.9976 0 5.2768 3.8749 8.8623 10.673 8.8623 4.2148 0 8.1577-1.4207 10.741-4.0591 3.1951-3.2472 4.2148-6.0886 4.2148-12.2448v-3.1796z",
    fill: "url(#e)",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m164.786 23.08v-10.08h9.041v10.08zm0 62.4421v-51.7532h9.041v51.7532z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m164.786 23.08v-10.08h9.041v10.08zm0 62.4421v-51.7532h9.041v51.7532z",
    fill: "url(#f)",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m224.473 50.0046h-8.77c0-6.9004-4.282-10.6889-11.556-10.6889-6.255 0-10.129 2.8413-10.129 7.3063 0 5.4121 3.806 6.2916 12.508 8.3211 9.517 2.3678 19.646 4.465 19.646 16.5069 0 9.2682-7.953 15.4922-20.598 15.4922-13.596 0-21.686-6.4946-21.822-18.6718h9.11c0 7.4417 4.691 11.5007 12.78 11.5007 6.73 0 11.285-3.0443 11.285-7.7122 0-6.021-4.283-7.1034-14.344-9.6065-8.701-2.1648-17.607-3.8561-17.607-15.1539 0-8.8623 7.886-14.9509 19.239-14.9509 12.712 0 20.258 6.2239 20.258 17.657z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m224.473 50.0046h-8.77c0-6.9004-4.282-10.6889-11.556-10.6889-6.255 0-10.129 2.8413-10.129 7.3063 0 5.4121 3.806 6.2916 12.508 8.3211 9.517 2.3678 19.646 4.465 19.646 16.5069 0 9.2682-7.953 15.4922-20.598 15.4922-13.596 0-21.686-6.4946-21.822-18.6718h9.11c0 7.4417 4.691 11.5007 12.78 11.5007 6.73 0 11.285-3.0443 11.285-7.7122 0-6.021-4.283-7.1034-14.344-9.6065-8.701-2.1648-17.607-3.8561-17.607-15.1539 0-8.8623 7.886-14.9509 19.239-14.9509 12.712 0 20.258 6.2239 20.258 17.657z",
    fill: "url(#g)",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m259.544 17.8013c-8.64-1.9481-15.39-8.73271-17.415-17.331077-.068-.335874-.338-.470223-.608-.470223s-.54.134349-.607.470223c-1.958 8.598367-8.775 15.315877-17.416 17.331077-.675.1343-.675 1.0076 0 1.2091 8.641 1.9481 15.391 8.7328 17.416 17.3311.067.3359.337.4702.607.4702s.54-.1343.608-.4702c1.957-8.5983 8.775-15.3158 17.415-17.3311.608-.2015.608-1.0748 0-1.2091zm-18.023 7.2549c-1.822-2.5527-4.117-4.8366-6.682-6.6503 2.565-1.8137 4.86-4.0977 6.682-6.6503 1.823 2.5526 4.118 4.8366 6.683 6.6503-2.565 1.8137-4.793 4.0305-6.683 6.6503z",
    fill: "#f4a81d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m259.544 17.8013c-8.64-1.9481-15.39-8.73271-17.415-17.331077-.068-.335874-.338-.470223-.608-.470223s-.54.134349-.607.470223c-1.958 8.598367-8.775 15.315877-17.416 17.331077-.675.1343-.675 1.0076 0 1.2091 8.641 1.9481 15.391 8.7328 17.416 17.3311.067.3359.337.4702.607.4702s.54-.1343.608-.4702c1.957-8.5983 8.775-15.3158 17.415-17.3311.608-.2015.608-1.0748 0-1.2091zm-18.023 7.2549c-1.822-2.5527-4.117-4.8366-6.682-6.6503 2.565-1.8137 4.86-4.0977 6.682-6.6503 1.823 2.5526 4.118 4.8366 6.683 6.6503-2.565 1.8137-4.793 4.0305-6.683 6.6503z",
    fill: "url(#h)",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/Logo_Transparent.de45010c64a854c2dc1bbcd5d71fed85.svg";
export { ForwardRef as ReactComponent };